import { render, staticRenderFns } from "./ParsianTransaction.vue?vue&type=template&id=60026bb8&scoped=true&"
import script from "./ParsianTransaction.vue?vue&type=script&lang=js&"
export * from "./ParsianTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ParsianTransaction.vue?vue&type=style&index=0&id=60026bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60026bb8",
  null
  
)

export default component.exports